module.exports = __webpack_public_path__ + "static/img/tow.18ee561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wardrobeImg/tow.png
// module id = xXMf
// module chunks = 1